import { __assign } from "tslib";
import { connect } from 'react-redux';
import { verifyPassword } from '../actionCreators';
import Password from '../components/Password';
function mapStateToProps(state) {
    return __assign({ projectID: state.project.config.id }, state.password);
}
function mapDispatchToProps(dispatch) {
    return {
        onSubmit: function (projectID, password) {
            return dispatch(verifyPassword(projectID, password));
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Password);
